<div class="w-full" id="chain-hotels">
  <iho-swiper [dataSource]="dataSource?.Section?.Data.Details" [configs]="sliderConfigsRev" />
</div>

<div class="w-full my-5 md:hidden" id="chain-hotels">
  <iho-swiper [dataSource]="dataSource?.Section?.Data.Details" [configs]="sliderConfigsRev" />
</div>

<ng-template #template let-data="data" let-i="index">
  <ng-container *ngIf="data?.PictureUrl">
    <a [href]="data.Url"
      class="rounded-lg object-contain h-[124px] w-[124px] flex justify-center items-center bg-white grayscale hover:grayscale-0 transition-all">
      <img [ngSrc]="data.PictureUrl" (error)="data.PictureUrl = cdnUrl + '/images/no-image.jpg'"
        [alt]="data.PictureName" height="90" width="90" class="h-24 w-24">
    </a>
  </ng-container>
</ng-template>